<div class="dialogContent calcHeight content">
  <irb-settings-dialog-banner
    [accordian]="accordion"
    [showUnsavedChangesWarning]="showUnsavedChangesWarning"
    [isModified]="isModified"
    [validationErrorTemplates]="validationErrorTemplates"
  (save)="save()">Securities</irb-settings-dialog-banner>
  <div class="body">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      @if (globalSettings && ENABLE_SETTINGS_HIST) {
        <mat-expansion-panel [expanded]="false" (opened)="iss.updateExpansionState('HISTORY','opened')" (closed)="iss.updateExpansionState('HISTORY','closed')">
          <mat-expansion-panel-header>
              <mat-panel-title>
                  Settings History
              </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
              <irb-settings-history tabName="Securities"></irb-settings-history>
          </ng-template>
        </mat-expansion-panel>
      }

      @if (globalSettings) {
        <mat-expansion-panel id="SCHWAB_SEC_CLASS" [expanded]="iss.getDefaultExpansionState('SCHWAB_SEC_CLASS')" (opened)="iss.updateExpansionState('SCHWAB_SEC_CLASS','opened')" (closed)="iss.updateExpansionState('SCHWAB_SEC_CLASS','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Schwab&reg; Asset Classes
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="block">Schwab Asset Classes are included in iRebal. Your securities are automatically categorized using Schwab's classifications, giving you unparalleled insight into millions of stocks, ETFs and mutual funds.</div>
          <div class="left">
          <button [disabled]="!isadmin" (click)="openSecurityMaster()" class="btn-medium-primary chevron-right">Go to Securities</button>
            <button [disabled]="!isadmin" (click)="showViewAssetClassesDialog()" class="btn-medium-primary chevron-right btn-spacer">View Schwab Asset Classes</button>
          </div>
        </mat-expansion-panel>
      }

      @if (globalSettings) {
        <mat-expansion-panel id="CUSTOM_SEC_CLASS" [expanded]="iss.getDefaultExpansionState('CUSTOM_SEC_CLASS')" (opened)="iss.updateExpansionState('CUSTOM_SEC_CLASS','opened');custCatPanelExpanded=true;" (closed)="iss.updateExpansionState('CUSTOM_SEC_CLASS','closed');custCatPanelExpanded=false;">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Custom Security Categories
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (custCatPanelExpanded) {
            <div>
              <div class="block"><strong>Category Column</strong></div>
              <div class="block irb-border-box">
                <div class="dblock">
                  <span class="left">Customize the column name and description to organize your securities.</span>
                  <span class="right"><button [disabled]="!isadmin || showClassificationColumnEdit"  class="btn-medium-primary" (click)="toggleClassificationColumnEdit()">Edit Details</button></span>
                  <br class="clear"/>
                </div>
                <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
                  <div class="bold" style="width: 130px">Column Name</div>
                  @if (showClassificationColumnEdit) {
                    <div>
                      <div class="hblock"><irb-validation-text-box #columnNameInput id="portfolioCustLabelAbbr"
                        max="25"
                        [(value)]="globalSettings.securityCustAttrAbbr"
                        width="278px"
                        [disabled]="!isadmin"
                        (valueChange)="onInputChange()"
                        isRequired="true"
                      ></irb-validation-text-box></div>
                      <div style="color: #999999; font-size: 10px;">25 characters max</div>
                    </div>
                  }
                  @if (!showClassificationColumnEdit) {
                    <div>{{globalSettings.securityCustAttrAbbr}}</div>
                  }
                </div>
                <div style="display: flex; flex-direction: row; gap: 10px;" [ngClass]="{'block bottomBorder': showClassificationColumnEdit}">
                  <div class="bold" style="width: 130px">Column Description</div>
                  @if (showClassificationColumnEdit) {
                    <div>
                      <textarea rows="2" maxlength="50" id="w3review" (keyup)="onInputChange()" [(ngModel)]="globalSettings.securityCustAttrDesc" cols="36" [disabled]="!isadmin"></textarea>
                      <div style="color: #999999; font-size: 10px;">(Optional) 50 characters max</div>
                    </div>
                  }
                  @if (!showClassificationColumnEdit) {
                    <div>{{globalSettings.securityCustAttrDesc}}</div>
                  }
                </div>
                @if (showClassificationColumnEdit) {
                  <div class="buttonSet">
                    <button [disabled]="!isadmin"  class="btn-medium-secondary incognito" (click)="revertClassificationColumnEdit()">Cancel</button>
                    <button [disabled]="!isadmin || columnNameInput?.inputControl.invalid"  class="btn-medium-primary btn-spacer" (click)="toggleClassificationColumnEdit()">Done</button>
                  </div>
                }
              </div>
              <div class="block">
                <strong>Categories</strong>
                <span class="right"><a (click)="export()">Export Categories</a>&nbsp;<fa-icon id="exportLink" [icon]="faDownload" class="irb-blue clickable" tooltip tooltipTitle="Export Categories" (click)="export()"></fa-icon></span>
              </div>
              <div class="block">Choose how to classify your securities. Create your own custom values or use Morningstar's existing values.</div>
              <div class="block irb-border-box">
                <mat-tab-group style="clear: both;" animationDuration="0ms" dynamicHeight>
                  <mat-tab label="Custom">
                    <ng-template matTabContent>
                      <div style="padding: 10px 10px 0px 10px;">
                        <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
                          <div class="bold" style="width: 170px">Category Name</div>
                          <div>
                            <div class="hblock"><irb-validation-text-box #labelNameInput id="newPortfolioCustLabelAbbr"
                              max="25"
                              [(value)]="newSecurityCustLabelAbbr"
                              width="278px"
                              [disabled]="!isadmin"
                              (valueChange)="onNewSecurityCustLabelAbbrChange()"
                              [isRequired]="isNewSecurityCustLabelAbbrRequired"
                              [regExp]="labelNamesRegExp"
                              invalidMessage="The value entered is not valid."
                              (keyup.enter)="addCategoryMenuItem()"
                            ></irb-validation-text-box></div>
                            <div style="color: #999999; font-size: 10px;">25 characters max</div>
                          </div>
                        </div>
                        <div class="block bottomBorder" style="display: flex; flex-direction: row; gap: 10px;">
                          <div class="bold" style="width: 170px">Category Description</div>
                          <div>
                            <div class="hblock"><irb-validation-text-box #labelDescriptionInput id="newSecurityCustLabelDesc"
                              max="50"
                              [(value)]="newSecurityCustLabelDesc"
                              width="278px"
                              [disabled]="!isadmin"
                              (valueChange)="validateCategoryMenuItem()"
                              invalidMessage="The value entered is not valid."
                              (keyup.enter)="addCategoryMenuItem()"
                            ></irb-validation-text-box></div>
                            <div style="color: #999999; font-size: 10px;">(Optional) 50 characters max</div>
                          </div>
                        </div>
                        <div class="block bottomBorder" style="text-align: right;">
                          <button class="btn-medium-secondary btn-spacer" id="addButton" label="Add"
                            [disabled]="!isadmin || (!newSecurityCustLabelAbbr || newSecurityCustLabelAbbr?.length == 0)"
                          (click)="addCategoryMenuItem()">Add</button>
                        </div>
                        @if (gridOptions && !isUiTest) {
                          <div>
                            <irb-inventory-grid
                              [style.width]="'100%'"
                              [style.height]="'240px'"
                              [gridHeight]="'205px'"
                              [showSideBar]="false"
                              [gridOptions]="gridOptions"
                              [footerContent]="footerContent"
                              [frameworkComponents]='frameworkComponents'
                              (cellValueChanged)="onGridChange($event)"
                              (gridReady)="onGridReady($event)">
                            </irb-inventory-grid>
                          </div>
                        }
                      </div>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="Morningstar">
                    <ng-template matTabContent>
                      <div style="padding: 10px 10px 0px 10px;">
                        <div class="block">
                          <irb-pick-list [(sourceData)]="leftSourceData" [(targetData)]="rightTargetData" (onMoveToTarget)="btnAdd($event)" (onMoveToSource)="btnRemove($event)" (onMoveAllToTarget)="btnAddAll()" (onMoveAllToSource)="btnRemoveAll()" (onApplyFilter)="applyFilter($event)"></irb-pick-list>
                        </div>
                        <div class="buttonSet">
                          <button [disabled]="!isadmin || (!morningstarValuesModified && !morningstarValuesStaged)"  class="btn-medium-secondary incognito" (click)="revertSuggestedCustomValues()">Discard Changes</button>
                          <button [disabled]="!isadmin || !morningstarValuesStaged"  class="btn-medium-primary btn-spacer" (click)="saveSuggestedCustomValues()">Done</button>
                        </div>
                      </div>
                    </ng-template>
                  </mat-tab>
                </mat-tab-group>
              </div>
              <div class="block"><strong>Automatic mapping</strong></div>
              <div class="hblock">Would you like iRebal to map your securities to Morningstar classifications?</div>
              <div class="block note hint">Only mutual funds and ETFs can be categorized.</div>
              <div class="hblock">
                <p-checkbox [disabled]="!isadmin" name="groupname" [(ngModel)]="morningStarCatAutoMapCurrent" (onChange)="updateOptions()" label="Enable automatic mapping" binary="true" inputId="ssitem1"></p-checkbox>
                <label for="ssitem1">Enable automatic mapping</label>
              </div>
              <div class="dblock" style="padding-left: 20px;">
                <div class="hblock">
                  <p-radioButton name="RestoreGroup" value="OverrideingExistingCategories" label="To all securities" [disabled]='(!isadmin)?true:(!morningStarCatAutoMapCurrent)?true:false' (ngModelChange)="onInputChange()" [(ngModel)]="globalSettings.morningStarCatAutoMap" inputId="ssitem2"></p-radioButton>
                  <label for="ssitem2" [class.p-disabled]="(!isadmin)?true:(!morningStarCatAutoMapCurrent)?true:false">To all securities</label>
                </div>
                <div class="hblock">
                  <p-radioButton name="RestoreGroup" value="UpdateUncategorizedSecurities" label="To uncategorized securities only" [disabled]='(!isadmin)?true:(!morningStarCatAutoMapCurrent)?true:false' (ngModelChange)="onInputChange()" [(ngModel)]="globalSettings.morningStarCatAutoMap" inputId="ssitem3"></p-radioButton>
                  <label for="ssitem3" [class.p-disabled]="(!isadmin)?true:(!morningStarCatAutoMapCurrent)?true:false">To uncategorized securities only</label>
                </div>
                <div>
                  <p-radioButton name="RestoreGroup" value="ApplyToNewSecuritiesOnly" label="To all securities going forward only (existing values remain)" (ngModelChange)="onInputChange()" [disabled]='(!isadmin)?true:(!morningStarCatAutoMapCurrent)?true:false' [(ngModel)]="globalSettings.morningStarCatAutoMap" inputId="ssitem4"></p-radioButton>
                  <label for="ssitem4" [class.p-disabled]="(!isadmin)?true:(!morningStarCatAutoMapCurrent)?true:false">To all securities going forward only (existing values remain)</label>
                </div>
              </div>
              <div class="block"><strong>Manual mapping</strong></div>
              <div class="block">Manually assign your classifications to your securities according to your preferences.</div>
              <div class="block bottomBorder"><button [disabled]="!isadmin" (click)="openSecurityMaster()" class="btn-medium-primary chevron-right">Go to Securities</button></div>
              <div class="hint">*Schwab and Morningstar are not affiliated.</div>
            </div>
          }
        </mat-expansion-panel>
      }

      @if (globalSettings) {
        <mat-expansion-panel id="IMPORT_SEC" [expanded]="iss.getDefaultExpansionState('IMPORT_SEC')" (opened)="iss.updateExpansionState('IMPORT_SEC','opened')" (closed)="iss.updateExpansionState('IMPORT_SEC','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Import Securities
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="block">You can import missing securities for your environment. The import runs in the background, allowing you to continue using iRebal. A notification will display when the process is complete. Note: This import can be run only once per day.</div>
          <button [disabled]="!isadmin || isImpSecJobSubToday"  class="btn-medium-primary import" (click)="invokeImportSecuritiesJob()" title="This import can be run only once per day.">Import</button>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>

  <ng-template #assetCategoryNameTemplate>
    <div class="block">Create your own category for organizing securities - by asset class, industry, or whatever system works best for you to identify and organize security types.</div>
    <div>Give your custom asset category a description and abbreviation - e.g. label it as "Asset Class" or "Sector." The abbreviation will be the column label.</div>
  </ng-template>
  <ng-template #columnNameValidationErrorTemplate>
    The 'Column Name' field cannot be empty. Enter a <a (click)="focusColumnNameInput()">Column Name</a>.
  </ng-template>
  <ng-template #labelNameValidationErrorTemplate>
    The 'Category Name' field cannot be empty. Enter a <a (click)="focusLabelNameInput()">Category Name</a>.
  </ng-template>
  <ng-template #labelNameExistsValidationErrorTemplate>
    '{{newSecurityCustLabelAbbr}}' is already in use. Enter a different <a (click)="focusLabelNameInput()">Category Name</a>.
  </ng-template>
  <ng-template #labelNameInvalidCharValidationErrorTemplate>
    '{{newSecurityCustLabelAbbr}}' may not contain a '^'. Enter a different <a (click)="focusLabelNameInput()">Category Name</a>.
  </ng-template>
  <ng-template #labelNameInvalidPrefixValidationErrorTemplate>
    '{{newSecurityCustLabelAbbr}}' may not be prefixed with +, -, = or &#64;. Enter a different <a (click)="focusLabelNameInput()">Category Name</a>.
  </ng-template>
  <ng-template #labelDescInvalidPrefixValidationErrorTemplate>
    '{{newSecurityCustLabelDesc}}' may not be prefixed with +, -, = or &#64;. Enter a different <a (click)="focusLabelDescriptionInput()">Category Description</a>.
  </ng-template>
  <ng-template #labelNameGridValidationErrorTemplate>
    One or more entries in Categories are invalid.
  </ng-template>
